import { SearchPropertyStatus } from '../types';
import {
  GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_LABEL_DEFAULT,
  GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_VALUE_DEFAULT,
  SEARCH_API_SORT_OPTION_LABEL_BY_PROPERTY_STATUS_DEFAULT,
  SEARCH_API_SORT_OPTION_VALUE_BY_PROPERTY_STATUS_DEFAULT,
} from './defaults';

export const getDefaultSortOption = ({
  isGeoShapeBasedSearch,
  propertyStatus,
}: {
  isGeoShapeBasedSearch: boolean;
  propertyStatus: SearchPropertyStatus;
}) => {
  if (isGeoShapeBasedSearch && propertyStatus === SearchPropertyStatus.sold)
    return {
      defaultLabel: GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_LABEL_DEFAULT,
      defaultValue: GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_VALUE_DEFAULT,
    };

  return {
    defaultLabel: SEARCH_API_SORT_OPTION_LABEL_BY_PROPERTY_STATUS_DEFAULT[propertyStatus],
    defaultValue: SEARCH_API_SORT_OPTION_VALUE_BY_PROPERTY_STATUS_DEFAULT[propertyStatus],
  };
};
